<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<h5>{{ $t('documentPage.title') }}</h5>
				<p>{{ $t('documentPage.placeholder') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {

}
</script>
